import React, { Component } from 'react';
import { isEmpty } from "lodash"
import { Box, CircularProgress, Paper, Typography, IconButton, Tooltip } from '@mui/material';
import { makeStyles } from "@mui/styles";
import { TuneRounded } from '@mui/icons-material';
import Currency from '../../common/Currency';
import BudgetForm from './BudgetForm';
import SpendingBySubCategory from '../../Spendings/SpendingBySubCategory';

const useStyles = makeStyles((theme) => ({
    root: {
      position: "relative"
    },
    bottom: {
      color: "grey"
    },
    top: {
    //   color: "red",
      animationDuration: "550ms",
      position: "absolute",
      left: 0
    },
    circle: {
      strokeLinecap: "round"
    }
  }));
  
export const hex2rgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};
export function CircularProgressWithLabel(props) {
    const classes = useStyles();
    // console.log('====================================');
    // console.log({props});
    // console.log('====================================');
    let valueTop = props.value || 0
    let colorBottom = "rgba(0,0,0,.04)"
    let colorTop = hex2rgba(props.color, .9)
    if ((props.spent > props.max) && (props.max > 0)) {
        colorBottom = props.color 
        valueTop = props.value - 100
        colorTop =  "rgba(0,0,0,.45)"
    }
    // let colorTop = props.spent > props.max ? props.color : hex2rgba(props.color, .9)
    // let colorTop = props.spent > props.max ? hex2rgba(props.color) : hex2rgba(props.color, .8)
    return (
        <Box position="relative" display="inline-flex">
            <div className={classes.root}>
                <CircularProgress
                    variant="determinate"
                    // className={classes.bottom}
                    style={{color: colorBottom}} 
                    value={100}
                    size={160} 
                    thickness={3} 
                />
                <CircularProgress
                    variant="determinate"
                    disableShrink
                    className={classes.top}
                    style={{color: colorTop }}
                    classes={{ circle: classes.circle }}
                    size={160} 
                    thickness={3} 
                    value={valueTop}
                />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="caption" component="div" color="textSecondary">
                    <div><b><Currency value={Math.round(props.spent)} suffix={" "} /></b> / </div> <Currency value={Math.round(props.max)} suffix={" "} />
                </Typography>
                {/* <Typography variant="caption" component="div" color="textSecondary">
                    {`${Math.round(props.value)}%`}
                </Typography> */}
            </Box> 
            </div>
        </Box>
    );
}

class BudgetSingle extends Component {
    state = { 
        openForm: false,
        openDetails : false,
    }
    	
    filterData = () => {
		const { filter_period, filter_payment, SPENDINGS, view, start_date, end_date } = this.props;
		// let from = filter_period === "custom" ? start_date :  getLimitDate("year")
		let list = this.filterDate()
		
		return list
	}

	filterDate = () => {
		let filteredList = Object.values(this.props.SPENDINGS).filter( spending => 
            new Date(spending.spending_date).getFullYear() === this.props.budget_year
		)

		return filteredList
	}
	// filterDate = () => {
    //     let from = getLimitDate("year")
    //     let to = new Date(new Date().getFullYear(), 11, 31)
	// 	// console.log('====================================');
	// 	// console.log({from, to});
	// 	// console.log('====================================');
		
	// 	let filteredList = Object.values(this.props.SPENDINGS).filter( spending => 
	// 		new Date(spending.spending_date) >= from 
	// 		&& new Date(spending.spending_date) <= to
	// 	)

	// 	return filteredList
	// }

	groupBy = (array, prop) => {
		const { CHILD } = this.props.CATEGORIES;

		return array.reduce((acc, obj) => {
			if ( obj.spending_status === "VALIDATE" ){
				let childCatID = obj[prop]
				var key = CHILD[childCatID].category_parent
	
				if(!acc[key]){
					acc[key] = [];
				}
				acc[key].push(obj);
			}
				return acc;
		}, {});
	}
	
	getList = () => {
	
		const { CATEGORIES, filter_payment, SPENDINGS } = this.props;
        // console.log('====================================');
        // console.log({SPENDINGS});
        // console.log('====================================');
        let listQty = {}
        if (!isEmpty(SPENDINGS)){
            let list = this.filterData()
            listQty = this.groupBy(list, "spending_category")
        }

		return listQty
	}

    render() {
        const { CATEGORIES, category, BUDGETS, budget_year} = this.props;
        const { openForm, openDetails  } = this.state;
        
        let budget = {
            budget_max : 0, 
            budget_year, 
            category_id: category.category_id,
            category_parent: category.category_parent,
        }

        if ( BUDGETS && BUDGETS[budget_year] && BUDGETS[budget_year][category.category_id]) {
            budget = BUDGETS[budget_year][category.category_id] 
            budget.subCat = {}
            if (CATEGORIES.LIST[category.category_id]){
                CATEGORIES.LIST[category.category_id].forEach(child => {
                    if (BUDGETS[budget_year][child]){
                        budget.subCat[child] = BUDGETS[budget_year][child].budget_max
                    }
                })
            }
        }
        // console.log('====================================');
        // console.log({budget, category});
        // console.log('====================================');
        // let rest = max - category.budget_spent
        let color = category ? category.category_color : "grey"
        let cat_name = category ? category.category_name : ""

        let list = this.getList()
        return (
            <Paper elevation={0}>
                {openForm && 
                    <BudgetForm 
                        // category={category}
                        {...this.props}
                        budget={budget}
                        handleClose={() => this.setState({openForm: false})}
                    />

                }
                {openDetails && 
                    <SpendingBySubCategory 
						SPENDINGS={list[category.category_id]} 
						SPENDINGSLIST={this.props.SPENDINGS} 
						category={category.category_id} 
						CATEGORIES={CATEGORIES}
						BUDGETS={BUDGETS}
						LABELS={this.props.LABELS}
						SUPPLIERS={this.props.SUPPLIERS}
						BANKS={this.props.BANKS}
						view={"ADMIN"}
						fetchSpendingPayments={this.props.fetchSpendingPayments}
						handleClose={
							() => this.setState({ selectedCategory: "", openDetails: false})
						} 
                        noDateFilter
                        budget_max={budget.budget_max}
                        budget_year={budget_year}
                        isBudget
					/>

                }
                <Box p={2} style={{position: "relative"}} >
                    <Box style={{textAlign: "center"}} onClick={() => this.setState({ openDetails: true })}>

                        <Tooltip arrow placement="top" title={cat_name}>
                            <Typography variant="subtitle1" component="h6" noWrap>
                                {cat_name}
                            </Typography>
                        </Tooltip>

                        <CircularProgressWithLabel 
                            color={color} 
                            spent={category.budget_spent} 
                            max={budget.budget_max} 
                            value={category.budget_spent*100/(budget.budget_max || category.budget_spent)} 
                        />
                    </Box>
                     
                    <Box style={{textAlign: "right", position: "absolute", bottom: "1px", right: "1px"}}>
                        <Tooltip arrow placement="bottom" title="Modifier le budget">
                            <IconButton onClick={() => this.setState({openForm: true})} color="secondary">
                                <TuneRounded />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Paper>
        );
    }
}

export default BudgetSingle;